import { render, staticRenderFns } from "./NewLocationModal.vue?vue&type=template&id=b4cdf292&scoped=true"
import script from "./NewLocationModal.vue?vue&type=script&lang=ts"
export * from "./NewLocationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cdf292",
  null
  
)

export default component.exports